import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Toast from "../../components/Toast";
import CreatableSelect from 'react-select/creatable';
import customStyles, { styleSelect } from "../../constants/customStyles";
import { saveVehicle } from "../../actions/VehicleActions";
import { getAllState, saveState } from "../../actions/StateAction";
import { getAllColor, saveColor } from "../../actions/ColorActions";
import { getAllVehicleCode, saveVehicleCode } from "../../actions/VehicleCodeActions";
import { getAllVehicleType, saveVehicleType } from "../../actions/VehicleTypeActions";
import { getAllVehicleMake, saveVehicleMake } from "../../actions/VehicleMakeActions";
import { getAllVehicleModel, saveVehicleModel } from "../../actions/VehicleModelActions";
import { useEffect } from "react";
import { saveReplaceableVehicle } from "../../actions/ReplaceableVehicleActions";
import Mobilemenu from "../../layouts/mobile-menu";

function AddReplacementVehicle() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [plateNo, setPlateNo] = useState('');
    const [chasisNo, setChasisNo] = useState('');
    const [regExpiry, setRegExpiry] = useState('');
    const [serviceExpiry, setServiceExpiry] = useState('');
    const [serviceMile, setServiceMile] = useState('');
    const [note, setNote] = useState('');
    const [stateId, setStateId] = useState('');
    const [color, setColor] = useState('');
    const [vehicleCode, setVehicleCode] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [vehicleMake, setVehicleMake] = useState('');
    const [vehicleModel, setVehicleModel] = useState('');

    useEffect(() => {
            dispatch(getAllState(null, 9999, { status: 1 }));
            dispatch(getAllColor(null, 9999, { status: 1 }));
            dispatch(getAllVehicleCode(null, 9999, { status: 1 }));
            dispatch(getAllVehicleType(null, 9999, { status: 1 }));
            dispatch(getAllVehicleMake(null, 9999, { status: 1 }));
            dispatch(getAllVehicleModel(null, 9999, { status: 1 }));
         }, []);

    const state = useSelector(state => state?.state?.states?.data);
    const colors = useSelector(state => state?.color?.colors?.data);
    const vehicleTypes = useSelector(state => state?.vehicleType?.vehicleTypes?.data);
    const vehicleMaker = useSelector(state => state?.vehicleMaker?.vehicleMakers?.data);
    const vehicleCodes = useSelector(state => state?.vehicleCode?.vehicleCodes?.data);
    const vehicleModels = useSelector(state => state?.vehicleModel?.vehicleModels?.data);
    const loading = useSelector(state => state?.loading?.loading);

    const save = () => {
        if (plateNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Plate No is Required!'
            })
        } else if (chasisNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Chasis No is Required!'
            })
        } else if (regExpiry.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Reg. Expiry is Required!'
            })
        } else if (stateId.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'State is Required!'
            })
        } else if (vehicleCode.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Code is Required!'
            })
        } else if (color.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Color is Required!'
            })
        } else if (vehicleType.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Type is Required!'
            })
        } else if (vehicleMake.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Make is Required!'
            })
        } else if (vehicleModel.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Model is Required!'
            })
        } else {
            let data = {
                plate_number: plateNo,
                chasis_no: chasisNo,
                registration_expiry: regExpiry,
                service_date: serviceExpiry,
                service_mile: serviceMile,
                note: note,
                state_id: stateId?.state_id,
                code_id: vehicleCode?.vehicle_code_id,
                color_id: color?.color_id,
                vehicle_type_id: vehicleType?.vehicle_type_id,
                vehicle_make_id: vehicleMake?.vehicle_make_id,
                vehicle_model_id: vehicleModel?.vehicle_model_id,
            }
            dispatch(saveReplaceableVehicle(data, navigate));
        }
        // window.location.href = ('/vehicleType');
    }

    const handleChangeState = (e) => {
        setStateId({
            state_id: e.state_id,
            name: e.name
        })
    }
    const handleChangeVehicleCode = (e) => {
        setVehicleCode({
            vehicle_code_id: e.vehicle_code_id,
            name: e.name
        })
    }
    const handleChangeColor = (e) => {
        setColor({
            color_id: e.color_id,
            name: e.name
        })
    }
    const handleChangeVehicleType = (e) => {
        setVehicleType({
            vehicle_type_id: e.vehicle_type_id,
            name: e.name
        })
    }
    const handleChangeVehicleMake = (e) => {
        setVehicleMake({
            vehicle_make_id: e.vehicle_make_id,
            name: e.name
        })
    }
    const handleChangeVehicleModel = (e) => {
        setVehicleModel({
            vehicle_model_id: e.vehicle_model_id,
            name: e.name
        })
    }


    const [isLoading, setIsLoading] = useState(false);

    const handleCreateState = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveState(data));
            dispatch(getAllState(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleCode = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleCode(data));
            dispatch(getAllVehicleCode(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleType = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            dispatch(saveVehicleType(data))
            dispatch(getAllVehicleType(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleMake = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleMake(data))
            dispatch(getAllVehicleMake(null, 9999))
        }, 1000);
    }
    const handleCreateVehicleModel = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleModel(data));
            dispatch(getAllVehicleModel(null, 9999));
        }, 1000);
    }
    const handleCreateVehicleColor = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveColor(data));
            dispatch(getAllColor(null, 9999));
        }, 1000);
    }
    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center mt-8">
                        <h2 className="fs-lg fw-medium me-auto">
                            Add Replacement Vehicle
                        </h2>
                    </div>
                    {/* <!-- BEGIN: Form Layout --> */}
                    <div className="intro-y box p-5 mt-5">
                        <div className="grid columns-12">
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Plate Number <span className="text-theme-6">*</span> :</label>
                                <input id="crud-form-1" onChange={(e) => setPlateNo(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Plate Number..." />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Chasis No <span className="text-theme-6">*</span> :</label>
                                <input id="crud-form-1" onChange={(e) => setChasisNo(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Chasis No..." />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Registration Expiry :</label>
                                <input id="crud-form-1" onChange={(e) => setRegExpiry(e.target.value)} type="date" className="form-control w-full" />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Service Expiry :</label>
                                <input id="crud-form-1" onChange={(e) => setServiceExpiry(e.target.value)} type="date" className="form-control w-full" />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Service Km<span className="text-theme-6">*</span> :</label>
                                <input id="crud-form-1" onChange={(e) => setServiceMile(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Service Km" />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">State<span className="text-theme-6">*</span> :</label>
                                <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                    isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateState} styles={styleSelect}
                                    onChange={(e) => handleChangeState(e)} getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option.state_id}`} options={state && state.length > 0 ? state : []} />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Color<span className="text-theme-6">*</span> :</label>
                                <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                    isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleColor} styles={styleSelect}
                                    onChange={(e) => handleChangeColor(e)} getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option.color_id}`} options={colors && colors.length > 0 ? colors : []} />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Vehicle Code<span className="text-theme-6">*</span> :</label>
                                <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                    isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleCode} styles={styleSelect}
                                    onChange={(e) => handleChangeVehicleCode(e)} getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option.vehicle_code_id}`} options={vehicleCodes && vehicleCodes.length > 0 ? vehicleCodes : []} />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Vehicle Type<span className="text-theme-6">*</span> :</label>
                                <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                    isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleType} styles={styleSelect}
                                    onChange={(e) => handleChangeVehicleType(e)} getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option.vehicle_type_id}`} options={vehicleTypes && vehicleTypes.length > 0 ? vehicleTypes : []} />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Vehicle Make<span className="text-theme-6">*</span> :</label>
                                <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                    isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleMake} styles={styleSelect}
                                    onChange={(e) => handleChangeVehicleMake(e)} getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option.vehicle_make_id}`} options={vehicleMaker && vehicleMaker.length > 0 ? vehicleMaker : []} />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Vehicle Model<span className="text-theme-6">*</span> :</label>
                                <CreatableSelect formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                    isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleModel} styles={styleSelect}
                                    onChange={(e) => handleChangeVehicleModel(e)} getOptionLabel={(option) => `${option.name}`}
                                    getOptionValue={(option) => `${option.vehicle_model_id}`} options={vehicleModels && vehicleModels.length > 0 ? vehicleModels : []} />
                            </div>
                            <div className="g-col-12 g-col-md-4">
                                <label for="crud-form-1" className="form-label">Note</label>
                                <textarea id="crud-form-1" onChange={(e) => setNote(e.target.value)} type="text" className="form-control w-full" placeholder="Enter Note..." />
                            </div>
                        </div>
                        {/* <div className="mt-3">
                                    <label>Status</label>
                                    <div className="form-check form-switch mt-2">
                                        <input type="checkbox" className="form-check-input"/>
                                    </div>
                                </div> */}
                        <div className="text-end mt-5">
                            <button type="button" onClick={() => navigate('/replacementVehicle')} className="btn btn-outline-secondary w-24 me-1">Back</button>
                            <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                        </div>
                    </div>
                    {/* <!-- END: Form Layout --> */}
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddReplacementVehicle;